import React from 'react';
import { SparklesIcon } from 'lucide-react';
export function EmotionalTransition() {
  const scrollToOffer = () => {
    document.getElementById('offerta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 px-4 bg-blue-700 text-center relative overflow-hidden" data-id="element-63">
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-64">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-65">
          <defs data-id="element-66">
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-67">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1" data-id="element-68" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" data-id="element-69" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-70">
        <div className="flex justify-center mb-8" data-id="element-71">
          <div className="bg-yellow-400 p-4 rounded-full shadow-lg shadow-yellow-400/20" data-id="element-72">
            <SparklesIcon className="w-8 h-8 text-blue-900" data-id="element-73" />
          </div>
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-white mb-12 leading-tight" data-id="element-74">
          Ed è proprio per questo che abbiamo creato il{' '}
          <span className="text-yellow-400" data-id="element-75">Mega-Pack Educazione Fisica.</span>
        </h2>

        <div className="space-y-8 text-xl md:text-2xl text-blue-100 font-medium mb-12" data-id="element-76">
          <p className="bg-blue-800/40 p-6 rounded-2xl border border-blue-600/50" data-id="element-77">
            Immagina di poter preparare le tue lezioni{' '}
            <strong className="text-white" data-id="element-78">molto più velocemente.</strong>
          </p>
          <p className="bg-blue-800/40 p-6 rounded-2xl border border-blue-600/50" data-id="element-79">
            Immagina studenti{' '}
            <strong className="text-white" data-id="element-80">
              più coinvolti, più attivi e più motivati.
            </strong>
          </p>
          <p className="bg-blue-800/40 p-6 rounded-2xl border border-blue-600/50" data-id="element-81">
            Immagina di entrare in palestra sapendo{' '}
            <strong className="text-white" data-id="element-82">esattamente cosa fare</strong>, senza
            dover improvvisare.
          </p>
        </div>

        <button onClick={scrollToOffer} className="bg-green-500 hover:bg-green-400 text-white font-bold text-xl py-4 px-12 rounded-full shadow-lg transform hover:-translate-y-1 transition-all duration-300 border-b-4 border-green-700" data-id="element-83">
          VOGLIO QUESTO RISULTATO
        </button>
      </div>
    </section>;
}